/* eslint-disable react/jsx-curly-newline */
import React from 'react';
import { Redirect, Switch, useLocation } from 'react-router-dom';

import ChatList from '~/views/Chat/ChatList';
import ChatRoom from '~/views/Chat/ChatRoom';
import ConsultDisable from '~/views/Consult/ConsultDisable';
import ConsultDisableDetail from '~/views/Consult/ConsultDisable/Detail';
import ConsultDispute from '~/views/Consult/Dispute';
import ConsultDisputeTable from '~/views/Consult/Dispute/Table';
import ConsultAudit from '~/views/Consult/Audit';
import ConsultEmployee from '~/views/Consult/Employee';
import ConsultEmployeeDetail from '~/views/Consult/Employee/Detail';
import ConsultTransaction from '~/views/Consult/Transaction';
import ConsultTransactionDetail from '~/views/Consult/Transaction/Detail';
import ConsultUser from '~/views/Consult/User';
import ConsultUserDetail from '~/views/Consult/User/Detail';
import ReactivateUser from '~/views/Consult/User/ReactivateUser';
import DigitalWallet from '~/views/ConsultTransaction/DigitalWallet';
import DigitalWalletDetail from '~/views/ConsultTransaction/DigitalWallet/Detail';
import LimitDecision from '~/views/CreditTable/LimitDecision';
import ConsultLimitCT from '~/views/CreditTable/LimitDecision/Detail';
import LimitSolicitation from '~/views/CreditTable/LimitSolicitation';
import DetailLimitCT from '~/views/CreditTable/LimitSolicitation/Detail';
import ConsultProposalCT from '~/views/CreditTable/Proposal';
import DetailProposalCT from '~/views/CreditTable/Proposal/Detail';
import ConsultReactivateDecision from '~/views/CreditTable/ReactivateDecision';
import DetailReactivate from '~/views/CreditTable/ReactivateDecision/Detail';
import ConsultReportCT from '~/views/CreditTable/Report';
import DetailReportCT from '~/views/CreditTable/Report/Detail';
import CancelInactivity from '~/views/Files/CancelInactivity';
import FileCharge from '~/views/Files/Charge';
import Documents from '~/views/Files/Documents';
import DocumentsDetails from '~/views/Files/Documents/Details';
import DocumentSolicitationHistory from '~/views/Files/Documents/History';
import FileHistory from '~/views/Files/History';
import FilePositive from '~/views/Files/Positive';
import FileUpload from '~/views/Files/Upload';
import Forgot from '~/views/Forgot';
import ForgotNewPass from '~/views/ForgotNewPass';
import InvoiceDetail from '~/views/Invoice/Detail/index';
import Invoice from '~/views/Invoice/index';
import Register from '~/views/Register';
import RegisterOperator from '~/views/RegisterOperator';
import Report from '~/views/Report/index';
import Sales from '~/views/Sales';
import DetailSales from '~/views/Sales/Detail';
import SignIn from '~/views/SignIn';

import ActiveLimits from '~/views/Files/ActiveLimits';
import FileCustomerBase from '~/views/Files/CustomerBase';
import FileProposal from '~/views/Files/Proposal';
import AntecipationInvoice from '~/views/Invoice/AntecipationInvoice';
import AntecipationLoan from '~/views/Invoice/AntecipationLoan';
import AntecipationMethodPaymentLoan from '~/views/Invoice/AntecipationLoan/AntecipationPaymentMethod';
import AntecipationConferenceLoan from '~/views/Invoice/AntecipationLoan/AnticipationConference';
import AntecipationLoanHistory from '~/views/Invoice/AntecipationLoan/History';
import AntecipationPurchase from '~/views/Invoice/AntecipationPurchase';
import AntecipationMethodPayment from '~/views/Invoice/AntecipationPurchase/AntecipationPaymentMethod';
import AntecipationConference from '~/views/Invoice/AntecipationPurchase/AnticipationConference';
import AntecipationHistory from '~/views/Invoice/AntecipationPurchase/History';
import PrivateRoute from './privateRoute';
import PublicRoute from './publicRoute';

import { icons } from '~/assets';
import Dialog from '~/components/dialog';
import { useInactivityLogout } from '~/hooks/useInactivityLogout';
import { usePasswordExpiration } from '~/hooks/usePasswordExpiration';
import themes from '~/themes/themes';
import PurchaseInclusion from '~/views/Consult/PurchaseInclusion';
import InvoiceFile from '~/views/Files/InvoiceFile';
import HomeDash from '~/views/HomeDash';
import DashDetailsAvailableCredit from '~/views/HomeDash/DashAvailableCredits';
import DashDetailsAdhesions from '~/views/HomeDash/DashDetailsAdhesions';
import DashDetailsBenefitsRealTime from '~/views/HomeDash/DashDetailsBenefitsRealTime';
import DashDetailsClientBase from '~/views/HomeDash/DashDetailsClientBase';
import DashDetailsInvoicePaid from '~/views/HomeDash/DashDetailsInvoicePaid';
import DashDetailsLateInvoice from '~/views/HomeDash/DashDetailsLateInvoice';
import DashDetailsProposal from '~/views/HomeDash/DashDetailsProposal';
import DashDetailsProposalRealTime from '~/views/HomeDash/DashDetailsProposalRealTime';
import DashInvoiceClosing from '~/views/HomeDash/DashInvoiceClosing';
import DashProjection from '~/views/HomeDash/DashProjection';
import ClientSearch from '~/views/Invoice/ClientSearch';
import ClientSearchByDecision from '~/views/Invoice/ClientSearchByDecision';
import TransactionDecisionDetail from '~/views/Invoice/ClientSearchByDecision/Detail';
import ReportBenefit from '~/views/Report/Benefit';
import ReportCard from '~/views/Report/Card';
import ReportFinancial from '~/views/Report/Financial';
import ReportInvoice from '~/views/Report/Invoice';
import ReportLoan from '~/views/Report/Loan';
import ReportProposal from '~/views/Report/Proposal';
import ReportWallet from '~/views/Report/Wallet';
import EventBox from '~/views/Sales/EventsCenter';
import { LeadDecision } from '~/views/Sales/EventsCenter/Benefits/LeadDecision';
import { LeadSolicitation } from '~/views/Sales/EventsCenter/Benefits/LeadSolicitation';
import { DowngradeDecision } from '~/views/Sales/EventsCenter/Card/DowngradeDecision';
import { UpgradeDecision } from '~/views/Sales/EventsCenter/Card/UpgradeDecision';
import { UpgradeSolicitation } from '~/views/Sales/EventsCenter/Card/UpgradeSolicitation';
import { RequestEvent } from '~/views/Sales/EventsCenter/RequestEvent';
import { SolicitationDetails } from '~/views/Sales/EventsCenter/SolicitationDetails';

import { AccountLeadDetails } from '~/views/Sales/EventsCenter/Account/Details';

import HistoryLoan from '~/views/Consult/User/HistoryLoan';

import IndicationLinkList from '~/views/Sales/IndicationLink';
import IndicationLinkCreate from '~/views/Sales/IndicationLink/create';
import IndicationLinkDetails from '~/views/Sales/IndicationLink/details';

import ConsultCostumer from '~/views/Consult/ConsultCostumer';
import ConsultCostumerDetail from '~/views/Consult/ConsultCostumer/Detail';
import AppAccess from '~/views/Consult/ConsultCostumer/Detail/AppAccess';
import PasswordHistory from '~/views/Consult/ConsultCostumer/Detail/PasswordHistory';
import ConsultFacialBiometrics from '~/views/Consult/FacialBiometrics';
import FacialBiometricsDetail from '~/views/Consult/FacialBiometrics/detail';
import UnicoBiometricsDetail from '~/views/Consult/FacialBiometrics/detail/unico';
import ProposalResume from '~/views/CreditTable/Proposal/proposalResume';
import ReportEvents from '~/views/Report/Events';
import TeuPagEstablishment from '~/views/Teupag/Establishment';
import RegisterTeuPagEstablishment from '~/views/Teupag/Establishment/Detail';
import RegisterUserMaster from '~/views/Teupag/Establishment/Detail/PortalAccess';
import TeuPagParameters from '~/views/Teupag/parameters';
import TeuPagReport from '~/views/Teupag/report';

import StoreOpenningDashboard from '~/views/HomeDash/StoreOpenning';
import SustenanceDashboard from '~/views/HomeDash/Sustenance';

import BankNowBiometricsDetail from '~/views/Consult/FacialBiometrics/detail/banknow';
import UnlockBiometrics from '~/views/Consult/FacialBiometrics/detail/unlockBiometrics';
import DetailsProposalColdRegistration from '~/views/HomeDash/DashDetailsProposalRealTime/details';
import AntecipationInvoiceChoosePayment from '~/views/Invoice/AntecipationInvoice/AntecipationInvoiceChoosePayment';
import AntecipationInvoiceConference from '~/views/Invoice/AntecipationInvoice/AntecipationInvoiceConference';
import FinancialHistory from '~/views/Invoice/AntecipationInvoice/FinancialHistory';
import FutureInvoices from '~/views/Invoice/FutureInvoices';
import InvoiceExtract from '~/views/Invoice/InvoiceExtract';

import AgreementCard from '~/views/ConsultTransaction/AgreementCard';
import ConsultTransactionDetailAgreementCard from '~/views/ConsultTransaction/AgreementCard/detail';
import DashboardPush from '~/views/HomeDash/Push';
import InvoiceReprocessHistoricDetails from '~/views/Invoice/Reprocess/views/historic-details';
import InvoiceReprocessHistoricList from '~/views/Invoice/Reprocess/views/historic-list';
import InvoiceReprocessSolicitation from '~/views/Invoice/Reprocess/views/new-solicitation';
import InvoiceReprocessPendingDetails from '~/views/Invoice/Reprocess/views/pending-details';
import InvoiceReprocessPendingList from '~/views/Invoice/Reprocess/views/pending-list';

// Resource
import DebtNegotiationActiveAgreements from '~/views/DebtNegotiation/ActiveAgreements';
import DebtNegotiationActiveAgreementDetail from '~/views/DebtNegotiation/ActiveAgreements/Detail';
import DebtNegotiationClient from '~/views/DebtNegotiation/Client';
import DebtNegotiationClientSearch from '~/views/DebtNegotiation/ClientSearch';
import DebtNegotiationHistory from '~/views/DebtNegotiation/History';
import AuthorizedIps from '~/views/Resource/AuthorizedIps';
import LimitIncrease from '~/views/Resource/Campaing';
import Communication from '~/views/Resource/Campaing/Communication';
import DefineActionsCommunication from '~/views/Resource/Campaing/Communication/defineActionsCommunication';
import PreviewCommunication from '~/views/Resource/Campaing/Communication/previewCommunication';
import LimitIncreaseCreate from '~/views/Resource/Campaing/LimitIncrease';
import ListClientCampaing from '~/views/Resource/Campaing/ListClientCampaing';
import ManagementAppHome from '~/views/Resource/ManagementTools/ManagementAppHome';
import ManagementProducts from '~/views/Resource/ManagementTools/ManagementProducts';
import ParametersIndex from '~/views/Resource/Parameters';
import EventsCenterParameters from '~/views/Resource/Parameters/eventsCenter';

const Routes: React.FC = () => {
  const location = useLocation();
  const pathname = location.pathname as string;
  usePasswordExpiration(pathname);
  const {
    dialogIsOpen,
    dialogCountdownLabel,
    keepSessionActive,
    logoutByInactivity,
  } = useInactivityLogout(pathname);

  return (
    <>
      <Dialog
        icon={icons.warning}
        positiveLabel="Sim"
        negativeLabel="Não"
        open={dialogIsOpen}
        positiveAction={keepSessionActive}
        negativeAction={logoutByInactivity}
      >
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            gap: 8,
            fontSize: '1em',
            fontWeight: 300,
          }}
        >
          <span>
            Identificamos que a sessão está sem atividade, deseja continuar?
          </span>
          <span>
            Se você não responder em{' '}
            <strong
              style={{
                color: themes.colors.primary,
                fontWeight: 700,
              }}
            >
              {dialogCountdownLabel}
            </strong>
            , será deslogado automaticamente.
          </span>
        </div>
      </Dialog>
      <Switch>
        <PublicRoute path="/" exact component={SignIn} />
        <PublicRoute path="/forgot" component={Forgot} />
        <PublicRoute path="/forgotNewPass" component={ForgotNewPass} />

        {/*  esta rota nao esta em uso, retirar em uma prox oportunidade */}
        <PrivateRoute
          exact
          path="/register/operator"
          component={RegisterOperator}
        />
        <PrivateRoute
          exact
          path="/consult/employee/register"
          component={Register}
        />
        <PrivateRoute path="/homeDash" component={HomeDash} />
        <PrivateRoute path="/aberturaLoja" component={StoreOpenningDashboard} />
        <PrivateRoute
          path="/faturamentoSustentacao"
          component={SustenanceDashboard}
        />
        <PrivateRoute
          path="/dashDetailsProposal"
          component={DashDetailsProposal}
        />
        <PrivateRoute
          path="/dashDetailsClientBase"
          component={DashDetailsClientBase}
        />
        <PrivateRoute
          path="/dashDetailsAdhesions"
          component={DashDetailsAdhesions}
        />
        <PrivateRoute
          path="/dashDetailsBenefitsRealTime"
          component={DashDetailsBenefitsRealTime}
        />
        <PrivateRoute
          path="/dashDetailsProposalRealTime"
          component={DashDetailsProposalRealTime}
        />
        <PrivateRoute
          path="/detailsColdRegistration"
          component={DetailsProposalColdRegistration}
        />
        <PrivateRoute path="/fechamentoFatura" component={DashInvoiceClosing} />
        <PrivateRoute path="/faturasPagas" component={DashDetailsInvoicePaid} />
        <PrivateRoute
          path="/creditosDisponiveis"
          component={DashDetailsAvailableCredit}
        />
        <PrivateRoute
          path="/faturasEmAtraso"
          component={DashDetailsLateInvoice}
        />

        <PrivateRoute path="/dashProjection" component={DashProjection} />

        <PrivateRoute
          exact
          path="/consult-transaction/digital-wallet"
          component={DigitalWallet}
        />

        <PrivateRoute
          exact
          path="/consult-transaction/digital-wallet/detail"
          component={DigitalWalletDetail}
        />

        <PrivateRoute
          exact
          path="/consult/transaction"
          component={ConsultTransaction}
        />
        <PrivateRoute
          exact
          path="/consult/transaction/detail"
          component={ConsultTransactionDetail}
        />
        <PrivateRoute
          exact
          path="/consult/transaction/agreement"
          component={AgreementCard}
        />
        <PrivateRoute
          exact
          path="/consult/transaction/agreement/detail"
          component={ConsultTransactionDetailAgreementCard}
        />
        <PrivateRoute
          exact
          path="/consult/disable"
          component={ConsultDisable}
        />
        <PrivateRoute
          exact
          path="/consult/disable/detail"
          component={ConsultDisableDetail}
        />
        <PrivateRoute exact path="/consult/user" component={ConsultUser} />
        <PrivateRoute
          exact
          path="/consult/user/detail"
          component={ConsultUserDetail}
        />

        <PrivateRoute
          exact
          path="/consult/user/history-loan"
          component={HistoryLoan}
        />

        <PrivateRoute
          exact
          path="/consult/user/biometrics/detail"
          component={FacialBiometricsDetail}
        />

        <PrivateRoute
          exact
          path="/consult/user/biometrics/unico/detail"
          component={UnicoBiometricsDetail}
        />

        <PrivateRoute
          exact
          path="/consult/user/biometrics/banknow/detail"
          component={BankNowBiometricsDetail}
        />

        <PrivateRoute
          exact
          path="/consult/user/biometrics"
          component={ConsultFacialBiometrics}
        />

        <PrivateRoute
          exact
          path="/consult/user/unlock-biometrics"
          component={UnlockBiometrics}
        />

        <PrivateRoute exact path="/consult/audit" component={ConsultAudit} />
        <PrivateRoute
          exact
          path="/consult/employee"
          component={ConsultEmployee}
        />
        <PrivateRoute
          exact
          path="/consult/employee/detail"
          component={ConsultEmployeeDetail}
        />
        <PrivateRoute
          exact
          path="/consult/employee/passwordHistory/detail"
          component={PasswordHistory}
        />
        <PrivateRoute
          exact
          path="/consult/costumer/appAccess/detail"
          component={AppAccess}
        />
        <PrivateRoute
          exact
          path="/consult/costumer/passwordHistory/detail"
          component={PasswordHistory}
        />

        <PrivateRoute
          exact
          path="/consult/costumer"
          component={ConsultCostumer}
        />
        <PrivateRoute
          exact
          path="/consult/costumer/detail"
          component={ConsultCostumerDetail}
        />
        <PrivateRoute
          exact
          path="/consult/reactivate-user/detail"
          component={ReactivateUser}
        />

        <PrivateRoute
          exact
          path="/credit-table/proposal"
          component={ConsultProposalCT}
        />
        <PrivateRoute
          exact
          path="/credit-table/proposal/detail"
          component={DetailProposalCT}
        />
        <PrivateRoute
          exact
          path="/credit-table/limit/solicitation"
          component={LimitSolicitation}
        />
        <PrivateRoute
          exact
          path="/credit-table/limit/decision"
          component={LimitDecision}
        />
        <PrivateRoute
          exact
          path="/credit-table/limit/solicitation/detail"
          component={DetailLimitCT}
        />
        <PrivateRoute
          exact
          path="/credit-table/limit/decision/detail"
          component={ConsultLimitCT}
        />
        <PrivateRoute
          exact
          path="/credit-table/proposal/proposal-resume"
          component={ProposalResume}
        />

        <PrivateRoute
          exact
          path="/credit-table/report"
          component={ConsultReportCT}
        />
        <PrivateRoute
          exact
          path="/credit-table/report/detail"
          component={DetailReportCT}
        />
        <PrivateRoute
          exact
          path="/credit-table/reactivate/decision"
          component={ConsultReactivateDecision}
        />
        <PrivateRoute
          exact
          path="/credit-table/reactivate/decision/detail"
          component={DetailReactivate}
        />
        <PrivateRoute
          exact
          path="/consult/dispute"
          component={ConsultDispute}
        />
        <PrivateRoute
          exact
          path="/consult/dispute/table"
          component={ConsultDisputeTable}
        />
        <PrivateRoute exact path="/report/others" component={Report} />
        <PrivateRoute exact path="/report/benefit" component={ReportBenefit} />
        <PrivateRoute exact path="/report/wallet" component={ReportWallet} />
        <PrivateRoute exact path="/report/invoice" component={ReportInvoice} />
        <PrivateRoute
          exact
          path="/report/financial"
          component={ReportFinancial}
        />
        <PrivateRoute exact path="/report/card" component={ReportCard} />
        <PrivateRoute exact path="/report/loan" component={ReportLoan} />
        <PrivateRoute exact path="/report/events" component={ReportEvents} />
        <PrivateRoute
          exact
          path="/report/proposal"
          component={ReportProposal}
        />
        <PrivateRoute exact path="/sales" component={Sales} />
        <PrivateRoute exact path="/sales/detail" component={DetailSales} />
        <PrivateRoute
          exact
          path="/teu-pag/estabelecimento"
          component={TeuPagEstablishment}
        />
        <PrivateRoute
          exact
          path="/teu-pag/estabelecimento/detail"
          component={RegisterTeuPagEstablishment}
        />
        <PrivateRoute
          exact
          path="/teu-pag/estabelecimento/detail/portalAccess"
          component={RegisterUserMaster}
        />
        <PrivateRoute
          exact
          path="/teu-pag/parametros"
          component={TeuPagParameters}
        />
        <PrivateRoute exact path="/teu-pag/report" component={TeuPagReport} />
        <PrivateRoute exact path="/file/upload" component={FileUpload} />
        <PrivateRoute exact path="/file/history" component={FileHistory} />
        <PrivateRoute exact path="/file/documents" component={Documents} />
        <PrivateRoute
          exact
          path="/file/documents/history"
          component={DocumentSolicitationHistory}
        />
        <PrivateRoute
          exact
          path="/file/documents/detalhes"
          component={DocumentsDetails}
        />
        <PrivateRoute exact path="/file/charge" component={FileCharge} />
        <PrivateRoute exact path="/file/positive" component={FilePositive} />
        <PrivateRoute
          exact
          path="/file/cancel-inactivity"
          component={CancelInactivity}
        />
        <PrivateRoute exact path="/file/proposal" component={FileProposal} />
        <PrivateRoute
          exact
          path="/file/activeLimits"
          component={ActiveLimits}
        />
        <PrivateRoute
          exact
          path="/file/customer-base"
          component={FileCustomerBase}
        />
        <PrivateRoute exact path="/file/invoice-file" component={InvoiceFile} />
        <PrivateRoute exact path="/invoice" component={Invoice} />
        <PrivateRoute exact path="/invoice/detail" component={InvoiceDetail} />
        <PrivateRoute
          exact
          path="/invoice/antecipation"
          component={AntecipationInvoice}
        />
        <PrivateRoute
          exact
          path="/invoice/antecipation-loan"
          component={AntecipationLoan}
        />
        <PrivateRoute
          exact
          path="/invoice/antecipation/purchase"
          component={AntecipationPurchase}
        />
        <PrivateRoute
          exact
          path="/invoice/antecipation/conference"
          component={AntecipationConference}
        />
        <PrivateRoute
          exact
          path="/invoice/antecipation-loan/conference"
          component={AntecipationConferenceLoan}
        />
        <PrivateRoute
          exact
          path="/invoice/advance-financing/conference"
          component={AntecipationInvoiceConference}
        />
        <PrivateRoute
          exact
          path="/invoice/antecipation/payment"
          component={AntecipationMethodPayment}
        />
        <PrivateRoute
          exact
          path="/invoice/antecipation-loan/payment"
          component={AntecipationMethodPaymentLoan}
        />
        <PrivateRoute
          exact
          path="/invoice/advance-financing/payment"
          component={AntecipationInvoiceChoosePayment}
        />
        <PrivateRoute
          exact
          path="/invoice/purchase-inclusion"
          component={ClientSearch}
        />
        <PrivateRoute
          exact
          path="/invoice/purchase-inclusion/detail"
          component={PurchaseInclusion}
        />
        <PrivateRoute
          exact
          path="/invoice/purchase-decision"
          component={ClientSearchByDecision}
        />
        <PrivateRoute
          exact
          path="/invoice/purchase-decision/detail"
          component={TransactionDecisionDetail}
        />
        <PrivateRoute
          exact
          path="/invoice/antecipation/purchase/history"
          component={AntecipationHistory}
        />
        <PrivateRoute
          exact
          path="/invoice/antecipation-loan/purchase/history"
          component={AntecipationLoanHistory}
        />
        <PrivateRoute
          exact
          path="/invoice/advance-financing/history"
          component={FinancialHistory}
        />
        <PrivateRoute exact path="/sales/eventCenter" component={EventBox} />
        <PrivateRoute
          exact
          path="/sales/eventCenter/requestEvent"
          component={RequestEvent}
        />
        <PrivateRoute
          exact
          path="/sales/eventCenter/downgradeDecision"
          component={DowngradeDecision}
        />
        <PrivateRoute
          exact
          path="/sales/eventCenter/SolicitationDetails"
          component={SolicitationDetails}
        />
        <PrivateRoute
          exact
          path="/sales/eventCenter/upgradeSolicitation"
          component={UpgradeSolicitation}
        />
        <PrivateRoute
          exact
          path="/sales/eventCenter/upgradeDecision"
          component={UpgradeDecision}
        />
        <PrivateRoute
          exact
          path="/sales/eventCenter/leadSolicitation"
          component={LeadSolicitation}
        />
        <PrivateRoute
          exact
          path="/sales/eventCenter/leadDecision"
          component={LeadDecision}
        />
        <PrivateRoute
          exact
          path="/sales/eventCenter/accountLead/details"
          component={AccountLeadDetails}
        />
        <PrivateRoute path="/chat/room" component={ChatRoom} />
        <PrivateRoute path="/chat" component={ChatList} />

        <PrivateRoute
          path="/sales/indicationLink"
          component={IndicationLinkList}
        />
        <PrivateRoute
          path="/sales/indicationLinkCreate"
          component={IndicationLinkCreate}
        />
        <PrivateRoute
          path="/sales/indicationLinkEdit"
          component={IndicationLinkDetails}
        />

        <PrivateRoute
          exact
          path="/invoice/detail/futureInvoices"
          component={FutureInvoices}
        />
        <PrivateRoute
          exact
          path="/invoice/detail/extract"
          component={InvoiceExtract}
        />
        {/* REPROCESSAMENTO DE FATURA */}
        <PrivateRoute
          exact
          path="/invoice/reprocess/solicitation"
          component={InvoiceReprocessSolicitation}
        />
        <PrivateRoute
          exact
          path="/invoice/reprocess/pending"
          component={InvoiceReprocessPendingList}
        />
        <PrivateRoute
          exact
          path="/invoice/reprocess/pending/details"
          component={InvoiceReprocessPendingDetails}
        />
        <PrivateRoute
          exact
          path="/invoice/reprocess/historic"
          component={InvoiceReprocessHistoricList}
        />
        <PrivateRoute
          exact
          path="/invoice/reprocess/historic/details"
          component={InvoiceReprocessHistoricDetails}
        />
        <PrivateRoute exact path="/dashboard/push" component={DashboardPush} />

        {/* Resource */}
        {/* Campaing */}
        <PrivateRoute path="/campanha" component={LimitIncrease} />
        <PrivateRoute path="/criar-campanha" component={LimitIncreaseCreate} />
        <PrivateRoute
          path="/lista-cliente-campanha"
          component={ListClientCampaing}
        />
        {/* COMUNICAÇÃO */}
        <PrivateRoute path="/communication" component={Communication} />
        <PrivateRoute
          path="/communication-preview"
          component={PreviewCommunication}
        />
        <PrivateRoute
          path="/define-communication-actions"
          component={DefineActionsCommunication}
        />
        {/* PARAMETROS */}
        <PrivateRoute path="/parameters/all" component={ParametersIndex} />
        <PrivateRoute
          path="/parameters/events-center"
          component={EventsCenterParameters}
        />
        {/* Management Tools */}
        <PrivateRoute
          exact
          path="/management-tools/products"
          component={ManagementProducts}
        />
        <PrivateRoute
          exact
          path="/management-tools/personalize-app-home"
          component={ManagementAppHome}
        />
        <PrivateRoute
          exact
          path="/management-tools/authorized-ips"
          component={AuthorizedIps}
        />
        <PrivateRoute
          exact
          path="/negociacao-dividas/buscar-cliente"
          component={DebtNegotiationClientSearch}
        />
        <PrivateRoute
          exact
          path="/negociacao-dividas/cliente"
          component={DebtNegotiationClient}
        />
        <PrivateRoute
          exact
          path="/negociacao-dividas/acordos-ativos"
          component={DebtNegotiationActiveAgreements}
        />
        <PrivateRoute
          exact
          path="/negociacao-dividas/acordos-ativos/detalhes"
          component={DebtNegotiationActiveAgreementDetail}
        />
        <PrivateRoute
          exact
          path="/negociacao-dividas/historico"
          component={DebtNegotiationHistory}
        />
        <PrivateRoute
          exact
          path="/negociacao-dividas/historico/detalhes"
          component={DebtNegotiationActiveAgreementDetail}
        />
        <PrivateRoute exact path="/dashboard/push" component={DashboardPush} />
        <Redirect to="/homeDash" />
      </Switch>
    </>
  );
};

export default Routes;
